import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query DealBrands($limit: Int, $cursor: String, $filters: ListDealBrandFiltersInput) {
    dealBrands(limit: $limit, cursor: $cursor, filters: $filters) {
      results {
        uuid
        name
        description
        domain
        label
        approved
        parentId
        logoUrl
        bannerUrl
        status
      }
      total
      limit
      cursor
    }
  }
`

export const dealBrandsKey = getQueryNames(query)[0]

export default query
